var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"buscador-wrapper"},[_c('buscador-input'),_c('info-article')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }